import { NCWalletNfts } from '../nfts/NCWalletNfts';

export const NCWalletNftsTab = () => {
	return <NCWalletNfts />;
};
